import { OrderAuditEntity, OrderAuditContactEntity } from '../../types/process/order-audit';
import { MergedOrder } from '../../types/process/order';
import { BaseAPI } from '../manager/base';
import apiClient from '../apiClient';
import type { BaseResponse } from '../../types/base.dto';
import { OperationAction } from '../../types/process/operation-log';

export class OrderAuditAPI extends BaseAPI<OrderAuditEntity> {
  constructor() {
    super('/audit');
  }

  /**
   * 获取审核详情
   * @param orderNo 订单号
   */
  async getAudit(orderNo: string): Promise<BaseResponse<MergedOrder>> {
    const response = await apiClient.get<BaseResponse<MergedOrder>>(`${this.endpoint}/${orderNo}`);
    return response.data;
  }

  /**
   * 修改审核状态 (Action: suspend, resume, submit)
   * @param orderNo 订单号
   * @param action 动作
   * @param params 参数
   */
  async changeStatus(
    orderNo: string,
    action: OperationAction.Suspend | OperationAction.ResumeAudit | OperationAction.SubmitAudit,
    params?: Record<string, any>
  ): Promise<BaseResponse<any>> {
    const response = await apiClient.post(`${this.endpoint}/${orderNo}/actions`, {
      action,
      params: params ?? null,
    });
    return response.data;
  }
}

export const orderAuditApi = new OrderAuditAPI();

export default orderAuditApi;
